export default "__VITE_ASSET__BjbM87Rm__"